import React from 'react';
import {
  ViewButton,
  EditButton,
  OpenUrlButton,
  HtmlButton,
  ArchiveButton,
  ResetStatsButton,
} from '../Common/DataTable/tableActionButtons';
import { getFilter, getSort, getLabel } from '../Common/DataTable/tableHelpers';
import moment from 'moment';
import FromNow from '../Common/FromNow';

const createTableColumns = (
  openViewModal,
  openEdit,
  openHtmlModal,
  openArchiveAlert,
  campaigns,
  openResetStatsAlert,
) => [
  {
    title: 'Name',
    name: 'name',
  },
  {
    title: 'Campaign',
    name: 'campaignId',
    width: 300,
    getCellValue: (row) => getLabel(row.campaignId, campaigns),
  },
  {
    title: 'Landing Page',
    name: 'landingPageUrl',
    width: 320,
    getCellValue: (row) => row.landingPageUrl || '',
    formatterComponent: ({ value }) =>
      value ? (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          className="text-truncate d-inline-block"
          style={{ maxWidth: 300 }}>
          {value}
        </a>
      ) : (
        ''
      ),
  },
  {
    title: 'Clicks',
    name: 'clicks',
    width: 120,
    getCellValue: (row) => row?.stats?.clicks || 0,
  },
  {
    title: 'Views',
    name: 'views',
    width: 120,
    getCellValue: (row) => row?.stats?.views || 0,
  },
  {
    title: 'CTR',
    name: 'ctr',
    width: 120,
    getCellValue: (row) => (row?.stats?.clicks / row?.stats?.views) * 100 || 0,
    formatterComponent: ({ value }) => `${value ? value.toFixed(2) : 0}%`,
  },
  {
    title: 'Published',
    name: 'publicUrl',
    width: 80,
    getCellValue: (row) => (row.publicUrl ? 'yes' : 'no'),
    formatterComponent: ({ value }) =>
      value === 'yes' ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-warning font-size-12">NO</span>
      ),
  },
  {
    title: 'Archived',
    name: 'archived',
    width: 80,
    getCellValue: (row) => (row.archived ? 'yes' : 'no'),
    formatterComponent: ({ value }) =>
      value === 'yes' ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-warning font-size-12">NO</span>
      ),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => <FromNow value={value} />,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
    exportValue: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    title: 'Action',
    name: 'action',
    width: 240,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        {openViewModal && <ViewButton row={row} onPress={openViewModal} />}
        {openEdit && <EditButton row={row} onPress={openEdit} />}
        {openHtmlModal && <HtmlButton row={row} onPress={openHtmlModal} />}
        {openResetStatsAlert && (
          <ResetStatsButton row={row} onPress={openResetStatsAlert} />
        )}
        {openArchiveAlert && !row.archived && (
          <ArchiveButton row={row} onPress={openArchiveAlert} />
        )}
        {row.publicUrl && (
          <OpenUrlButton
            row={row}
            url={`${row.publicUrl}?timestamp=${Date.now()}`}
          />
        )}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
